import { RouteObject, Navigate } from 'react-router-dom';
import AppProviders from './providers';
import QuickLoanLayout from '@/components/layout/QuickLoanLayout';
import {
  AuthCallback,
  ErrorNotFound,
  LoanSetup,
  LoanOfficer,
  LandingLoanOfficer,
  Disclosure,
  SignUp,
} from '@/pages';
import { RouteHandleKey } from '@/utils';

// Routes configuration
const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppProviders />,
    children: [
      {
        index: true,
        element: <Navigate to="/quickloan" replace />,
      },
      // Disclosure routes - within authenticated context with QuickLoanLayout
      {
        path: 'disclosure',
        element: <QuickLoanLayout />,
        children: [
          {
            path: 'terms-of-use',
            element: <Disclosure />,
            handle: { key: RouteHandleKey.DISCLOSURE },
          },
          {
            path: 'confirmation-release',
            element: <Disclosure />,
            handle: { key: RouteHandleKey.DISCLOSURE },
          },
          {
            path: 'electronic-documents',
            element: <Disclosure />,
            handle: { key: RouteHandleKey.DISCLOSURE },
          },
        ],
      },
      {
        path: 'quickloan',
        element: <QuickLoanLayout />,
        children: [
          {
            index: true,
            element: <LoanOfficer />,
            handle: { key: RouteHandleKey.LOAN_OFFICER },
          },
          {
            path: 'landing-loan-officer',
            element: <LandingLoanOfficer />,
            handle: { key: RouteHandleKey.LANDING_LOAN_OFFICER },
          },
          {
            path: 'setup',
            element: <LoanSetup />,
            handle: { key: RouteHandleKey.LOAN_SETUP },
          },
          {
            path: 'signup',
            element: <SignUp />,
            handle: { key: RouteHandleKey.SIGN_UP },
          },
        ],
      },
      {
        path: 'auth/callback',
        element: <AuthCallback />,
      },
      {
        path: '*',
        element: <ErrorNotFound />,
      },
    ],
  },
];

export default routes;
